import React, { SFC } from 'react';

import { styles } from '../utils/styles';

export const Separator: SFC = () => <div className={styles.separator} />;
